import * as React from "react";
import { Check, FileText } from "lucide-react";

import { Button } from "@/components/ui/button";
import { MatchCandidateResponse } from "@/types/contract-family";

interface Props {
  candidate: MatchCandidateResponse;
  pending: boolean;
  onAccept: (candidate: MatchCandidateResponse) => void;
}

export const AmbiguousCandidateCard: React.FC<Props> = ({ candidate, pending, onAccept }) => (
  <div className="grid gap-2 border-b border-slate-100 px-4 py-3 last:border-b-0 md:grid-cols-[1fr_auto] md:items-center">
    <div className="min-w-0">
      <div className="flex min-w-0 items-center gap-2">
        <FileText className="h-4 w-4 shrink-0 text-slate-500" />
        <span className="truncate font-mono text-sm text-slate-950">{candidate.candidate_master_document_id}</span>
      </div>
      <div className="mt-1 flex flex-wrap items-center gap-2 text-xs text-slate-500">
        <span>{Math.round(candidate.confidence * 100)}% confidence</span>
        {candidate.reasoning && <span className="min-w-0 truncate">{candidate.reasoning}</span>}
      </div>
    </div>
    <Button type="button" size="xs" onClick={() => onAccept(candidate)} disabled={pending}>
      <Check className="mr-1 h-3.5 w-3.5" />
      Accept
    </Button>
  </div>
);
